export { Table } from './Table';
export type { TableProps } from './Table';
